/**
 * Chat Slice
 * Conversation state management
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  createdAt: string;
}

interface Conversation {
  id: string;
  customerPhone: string;
  messages: Message[];
}

export interface ChatState {
  conversations: Conversation[];
  activeConversation: string | null;
  loading: boolean;
}

const initialState: ChatState = {
  conversations: [],
  activeConversation: null,
  loading: false,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setConversations: (state, action: PayloadAction<Conversation[]>) => {
      state.conversations = action.payload;
    },
    addMessage: (state, action: PayloadAction<{ conversationId: string; message: Message }>) => {
      const conversation = state.conversations.find((c) => c.id === action.payload.conversationId);
      if (conversation) {
        conversation.messages.push(action.payload.message);
      }
    },
    setActiveConversation: (state, action: PayloadAction<string | null>) => {
      state.activeConversation = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setConversations, addMessage, setActiveConversation, setLoading } =
  chatSlice.actions;
export default chatSlice.reducer;
